import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import {AppSettings} from '../configs/app-settings.config'

/**
 * This is a singleton class
 */
@Injectable()
export class AppConfig {

    // API Related configs
    public apiPort:string = environment.port;
    public apiProtocol:string;
    public apiHostName:string;
    public baseApiPath:string;
    public baseApiPathWithoutContext: string;
    public serverContext:string;
    public globalErrorRouteURL:string;
    public locale
    public windowsHost = window.location.hostname;
    public serverHost  = this.windowsHost.includes("localhost") ? "product-dev-v2-nbu.metamorphosys.co.in" : this.windowsHost;


    constructor(private appSettings:AppSettings){
        this.locale = appSettings.defaultLocale;
        if(environment.tokenMode && environment.overRideHost){
            this.apiHostName = environment.serverHost;
            this.serverContext = environment.tokenServerContext;
        }
        if(environment.tokenMode && !environment.overRidePort){
            this.apiPort = window.location.port
        }
        if (this.apiProtocol===undefined){ 
            this.apiProtocol = window.location.protocol;
        }
        if (this.apiHostName === undefined) {
            this.apiHostName = window.location.hostname;
        }
        if(this.serverContext === undefined){
            this.serverContext = environment.tokenServerContext;
        }
        if (this.apiPort === undefined) {
            this.apiPort = window.location.port;
        }
        if (this.apiHostName.includes("infomud") || this.apiHostName.includes("heroku")) {
            this.baseApiPath = this.apiProtocol + "//" + this.apiHostName + "/";
            this.baseApiPathWithoutContext = this.apiProtocol + "//" + this.apiHostName + "/";
            this.globalErrorRouteURL = this.apiProtocol + "//" + this.apiHostName + ":" + this.apiPort + environment.serverContext
        }
        else{
            this.baseApiPath = this.apiProtocol + "//" + this.apiHostName + ":" + this.apiPort + this.serverContext;
            this.baseApiPathWithoutContext = this.apiProtocol + "//" + this.apiHostName + ":" + this.apiPort
            this.globalErrorRouteURL = this.apiProtocol + "//" + this.apiHostName + ":" + this.apiPort + environment.serverContext
        }
        if (this.locale === undefined) {
            this.locale = navigator.language;
        }
    }
}
